export default __webpack_public_path__ + "static/media/fMaltoBuza5.374e761c.png";